export const DEFAULT_IMAGE_QUALITY_TIER = '4K';
export const IMAGE_QUALITY_CHANGE_EVENT = 'image-quality-change';

export const IMAGE_QUALITY_TIER_OPTIONS = [
  { value: '1K', label: '1K' },
  { value: '2K', label: '2K' },
  { value: '4K', label: '4K' },
];

export const getStoredImageQualityTier = () => {
  const value = localStorage.getItem('image_quality_tier');
  return IMAGE_QUALITY_TIER_OPTIONS.some(opt => opt.value === value) ? value : DEFAULT_IMAGE_QUALITY_TIER;
};

export const setStoredImageQualityTier = (value) => {
  const next = IMAGE_QUALITY_TIER_OPTIONS.some(opt => opt.value === value)
    ? value
    : DEFAULT_IMAGE_QUALITY_TIER;
  localStorage.setItem('image_quality_tier', next);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(IMAGE_QUALITY_CHANGE_EVENT, {
      detail: { qualityTier: next },
    }));
  }
  return next;
};
